import type { ShopRepository } from "../../../domain/repositories/shop/shop-repository";
import type { ShopDetailDto } from "../../../domain/types/shop";
import { shopApiService } from "../../api/shop/shop-api-service";

export class ShopRepositoryImpl implements ShopRepository {
  async getShopHome(): Promise<ShopDetailDto> {
    const response = await shopApiService.getShopHome();

    if (response.data) {
      return response.data;
    }

    throw new Error(response.errorMsg || "쇼핑몰 정보 가져오기 실패.");
  }

  async getShopHomeById(shopId: number): Promise<ShopDetailDto> {
    const response = await shopApiService.getShopHomeById(shopId);

    if (response.data) {
      return response.data;
    }

    throw new Error(response.errorMsg || "쇼핑몰 정보 가져오기 실패.");
  }
}
